export class CF7_Checkbox {

    constructor(parent, field, fake_field)
    {
        this.parent = parent;
        this.fake_field = fake_field;
        this.field = field;
        this.checked = false;
        this.comunication_checked = false;

        console.log(this.fake_field);

        this.init();
    }

    init()
    {

        this.field.addEventListener('change', (e) => {
            this.toggle();
        });

        this.fake_field.addEventListener('click', (e) => {
            this.toggle();
        });
    }

    toggle()
    {
        this.checked = !this.checked;

        if (this.checked) {
            this.field.checked = true;

            this.fake_field.classList.add('is-checked');
        } else {
            this.field.checked = false;
            this.fake_field.classList.remove('is-checked');
        }
    }


}

export class CF7_Field_Validator {
    constructor(form)
    {
        this.form = form;
        let inputs = this.form.querySelectorAll('input, textarea, select');
        this.init();
        this.communication();
    }

    init()
    {
      // wait for ajax content and check div with class .wpcf7-not-valid-tip exists
        this.form.addEventListener('change', (e) => {
          // remove all class has-errors
            let fields = this.form.querySelectorAll('.form-field-wrapper');

            fields.forEach(field => {
                // check has erro messages
                if (field.querySelector('.wpcf7-not-valid-tip')) {
                    field.classList.add('has-errors');
                } else {
                    field.classList.remove('has-errors');

                  // check in not empty
                    let subfields = field.querySelectorAll('input, textarea, select');
                    subfields.forEach(subfield => {
                        if (subfield.value) {
                              field.classList.add('has-value');
                        } else {
                            field.classList.remove('has-value');
                        }
                    });
                }
            });
        });
    }

    inputsFocus()
    {
        this.inputs.forEach(input => {
            input.addEventListener('focus', (e) => {
                let field = e.target.closest('.form-field-wrapper');
                field.classList.add('is-focused');
            });
        input.addEventListener('blur', (e) => {
            let field = e.target.closest('.form-field-wrapper');
            field.classList.remove('is-focused');
          });
        });
    }

    communication()
    {


      console.log(this.form);


      // get all checkboxes with name yl-zgody
        let checkboxes = this.form.querySelectorAll('input[name="yl-zgody[]"]');

        console.log(checkboxes);

      // set required for all checkboxes
        checkboxes.forEach(checkbox => {
            checkbox.required = true;
        });

      // if some checkbox is checked  remove required for others
        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                checkboxes.forEach(checkbox => {
                    checkbox.required = false;
                });
            } else {
                checkbox.required = true;
            }
        });
    }


}
